import { ExperimentFlag } from '@blisspointmedia/bpm-types/dist/FeatureExperiments';
import { ModalEditWidget } from '../../Components/ModalEditWidget';
import { truncate } from '../../utils/text-utils';
import { useCanEditExperiments } from './useCanEditExperiments';
import { useExperimentFlagTable } from './useExperimentFlagTable';
import { EMPTY_CELL_TEXT, formatExperimentsDate } from './utils';
import './ExperimentTable.scss';
import './ExperimentFlags.scss';

const headers = [
  {
    label: 'Experiment Flag',
    field: 'experiment_flag',
    type: 'text',
    flex: 3,
    modalRow: 0,
    modalFlex: 1,
    isInvalid: (experimentFlag: string) => !experimentFlag || experimentFlag.length === 0
  },
  {
    label: 'Description',
    field: 'description',
    type: 'text',
    flex: 6,
    modalRow: 0,
    modalFlex: 1,
    isInvalid: (description: string) => !description || description.length === 0,
    renderer: (data: ExperimentFlag) => {
      if (!data.description) {
        return <div className='empty-cell'>{EMPTY_CELL_TEXT}</div>;
      }
      return <div className='experiment-cell-text'>{truncate(data.description, 50)}</div>;
    }
  },
  {
    label: 'Disable UI Control',
    field: 'disable_ui_control',
    type: 'select',
    options: 'disable_ui_control',
    flex: 1,
    modalRow: 0,
    modalFlex: 1,
    renderer: (data: ExperimentFlag) => String(data.disable_ui_control)
  },
  {
    label: 'Created',
    field: 'created',
    type: 'text',
    flex: 2.5,
    modalRow: 0,
    modalFlex: 1,
    uneditable: true,
    renderer: (data: ExperimentFlag) =>
      data.created ? (
        <div>{formatExperimentsDate(data.created)}</div>
      ) : (
        <div className='empty-cell'>{EMPTY_CELL_TEXT}</div>
      )
  },
  {
    label: 'Last Modified',
    field: 'lastmodified',
    type: 'text',
    flex: 2.5,
    modalRow: 0,
    modalFlex: 1,
    uneditable: true,
    renderer: (data: ExperimentFlag) =>
      data.lastmodified ? (
        <div>{formatExperimentsDate(data.lastmodified)}</div>
      ) : (
        <div className='empty-cell'>{EMPTY_CELL_TEXT}</div>
      )
  },
  {
    label: 'Modified By',
    field: 'lastuser',
    type: 'text',
    flex: 3,
    modalRow: 0,
    modalFlex: 1,
    uneditable: true
  }
];

const SELECTOR_OPTIONS = {
  disable_ui_control: [
    { label: 'True', value: 'true' },
    { label: 'False', value: 'false' }
  ]
};

const MODAL_TITLE = (
  <div className='experiment-modal-container'>
    <div>New Experiment Flag</div>
    <div className='modal-subtitle'>
      Note: New flags will only work if they are an exact match for a flag implemented in code
    </div>
  </div>
);

export const ExperimentFlags = () => {
  const { initialTableData, onSaveModal, loading } = useExperimentFlagTable();
  const canEdit = useCanEditExperiments();

  return (
    <div className='experiment-table-page-container'>
      <ModalEditWidget<ExperimentFlag & { id: string }>
        name='Experiment Flags'
        className='experiment-table'
        headers={headers}
        initialTableData={initialTableData}
        onSaveModal={onSaveModal}
        selectorOptions={SELECTOR_OPTIONS}
        addButtonText='Add Experiment'
        readOnly={!canEdit}
        enableAdd={canEdit}
        modalTitle={MODAL_TITLE}
        isLoading={loading}
      />
    </div>
  );
};
